import {createContext} from "@lit/context";
import type {BridgeBarConfig} from "./BridgeBarConfig";

export const BridgeBarConfigContext = createContext<BridgeBarConfig>(
  "bridge-bar-config-context"
);
